export const SHOP_ITEMS = {
  generators: {
    basicBanker: {
      id: "basicBanker",
      name: "Junior Banker",
      description: "Generates pennies",
      cost: 100,
      type: "generator",
      generatorId: "BASIC_BANKER",
      icon: "👨‍💼"
    },
    financeAdvisor: {
      id: "financeAdvisor",
      name: "Finance Advisor",
      description: "Generates pennies and occasionally nickels",
      cost: 200,
      type: "generator",
      generatorId: "FINANCE_ADVISOR",
      icon: "👩‍💼"
    },
    investmentBroker: {
      id: "investmentBroker",
      name: "Investment Broker",
      description: "Generates pennies, nickels, and occasionally dimes",
      cost: 300,
      type: "generator",
      generatorId: "INVESTMENT_BROKER",
      icon: "💼"
    }
  },
  bundles: {
    starter: {
      id: "starter",
      name: "Starter Investment",
      description: "Perfect for beginners!",
      cost: 150,
      contents: {
        basicBanker: 1
      },
      savings: "25% OFF!",
      icon: "📦"
    },
    premium: {
      id: "premium",
      name: "Premium Portfolio",
      description: "Best value for serious investors!",
      cost: 300,
      contents: {
        basicBanker: 1,
        financeAdvisor: 1
      },
      savings: "35% OFF!",
      icon: "🎁"
    }
  }
};
